/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import {
  ALL_CATEGORY,
  DELETE_CATEGORY,
  CATEGORY_BASE_URL,
} from "../../constants/api";
import { Space, Button, Table } from "antd";
import { useNavigate } from "react-router-dom";
// import  { ColumnsType } from 'antd/es/table';
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Layout } from "antd";
import { Card } from "antd";
import { Image } from "antd";

function CategoryTabel() {
  const { Content } = Layout;
  const [state, setstate] = useState([]);
  const [loading, setloading] = useState(true);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (state.length === 0) {
      getCatgory();
    }
  }, [state]);
  const getCatgory = () => {
    setloading(true);
    const successFn = function (data) {
      console.log(data);

      if (data["status"] === true) {
        setstate(
          data["data"].map((row) => ({
            Name: row.title,
            Image: <Image width={50} src={CATEGORY_BASE_URL + row.image} />,
            ID: row.id,
            Action: (
              <Space>
                <Button
                  onClick={() => {
                    navigate("/category/edit/" + row.slug);
                  }}
                  block
                >
                  Edit
                </Button>
                <Button onClick={(e) => deleteCatgory(row.id)} danger>
                  Delete
                </Button>
              </Space>
            ),
          }))
        );
      } else {
        setstate([]);
      }
      setloading(false);
      console.log(state);
    };
    const errorFn = function () {
      setstate([]);
    };
    getAPI(ALL_CATEGORY, successFn, errorFn, {});
  };
  const deleteCatgory = (values) => {
    console.log(values);
    let data = {
      id: values,
    };
    const successFn = function (data) {
      getCatgory();
      displayMessage(SUCCESS_MESSAGE, "Data Delete Successfully");
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_CATEGORY, data, successFn, errorFn);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "Name",
      width: 150,
    },
    {
      title: "Image",
      dataIndex: "Image",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 150,
    },
  ];
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Manage Category"
            extra={
              <Button
                onClick={() => {
                  navigate("/category/add");
                }}
                block
              >
                Add Category
              </Button>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={state}
              pagination={{ pageSize: 10 }}
              // scroll={{ y: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default CategoryTabel;
